import axios from 'axios';

const API = `${window.location.origin}/api`;
const api = axios.create({ baseURL: API, withCredentials: true });

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export async function subscribeToPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  try {
    const registration = await navigator.serviceWorker.ready;
    const existingSub = await registration.pushManager.getSubscription();
    if (existingSub) {
      await api.post('/push/subscribe', existingSub.toJSON());
      return existingSub;
    }
    const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
    if (!vapidKey) return null;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey)
    });
    await api.post('/push/subscribe', subscription.toJSON());
    return subscription;
  } catch (e) {
    console.warn('Push subscription failed:', e);
    return null;
  }
}

export async function requestPushPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') {
    await subscribeToPush();
    return true;
  }
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  if (result === 'granted') {
    await subscribeToPush();
    return true;
  }
  return false;
}

export async function checkAbandonedCarts() {
  try { await api.post('/push/check-abandoned'); } catch {}
}

export async function checkScheduledPush() {
  try { await api.post('/push/check-scheduled'); } catch {}
}
